import React, { useState, useEffect } from "react"
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext'
import Block from "../../../components/Block/Block"
import FadeIn from "../../../components/FadeIn/FadeIn"
import YandexMap from '../../../components/YandexMap/YandexMap'
import style from './mapblock.module.scss'

const MapBlock = ({ center, branches, loading }, ref) => {
    const [isMobile, setIsMobile] = useState(false)
    const { settings: { contrast } } = useAccessibility()

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        checkScreenSize()
        window.addEventListener('resize', checkScreenSize)
        return () => window.removeEventListener('resize', checkScreenSize)
    }, [])

    // Функция для получения координат филиала
    const getBranchCoordinates = (branch) => {
        // Сначала пробуем получить coordinates
        if (branch.attributes.coordinates) {
            return branch.attributes.coordinates
        }
        // Если coordinates нет, используем map_x и map_y
        if (branch.attributes.MapY && branch.attributes.MapX) {
            return [branch.attributes.MapY, branch.attributes.MapX]
        }
        return null
    }

    // Получаем центр карты
    const getMapCenter = () => {
        if (center) return center
        
        if (branches.length > 0) {
            const firstBranchCoords = getBranchCoordinates(branches[0])
            if (firstBranchCoords) return firstBranchCoords
        }
        
        // Fallback координаты (Краснодар)
        return [45.0355, 38.9750]
    }

    return (
        <Block
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            width={isMobile ? '100%' : '75%'}
            height='fit-content'
            background={contrast !== 'default' ? 'var(--bg-primary)' : 'rgba(255, 255, 255, 0.85)'}
            header='РАСПОЛОЖЕНИЕ ФИЛИАЛОВ'
            ref={ref}
            padding={isMobile ? '1rem' : '2rem'}
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.left}>
                        {loading ? (
                            <div>Загрузка филиалов...</div>
                        ) : (
                            branches.map(branch => (
                                <div key={branch.id} className={style.unit}>
                                    <div className={style.title}>
                                        <h3>{branch.attributes.Title}</h3>
                                    </div>
                                    <div className={style.wrapperAddress}>
                                        <p className={style.address}>
                                            <strong>Адрес:</strong> {branch.attributes.Address}
                                        </p>
                                        <p className={style.contact}>
                                            <strong>Телефон:</strong> {branch.attributes.Phone}
                                        </p>
                                        {branch.attributes.Email && (
                                            <p className={style.contact}>
                                                <strong>Email:</strong> {branch.attributes.Email}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    <div className={style.right}>
                        <YandexMap
                            width='100%'
                            height={isMobile ? '300px' : '400px'}
                            center={getMapCenter()}
                            zoom={15}
                            branches={branches.filter(branch => getBranchCoordinates(branch) !== null)}
                        />
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default React.forwardRef(MapBlock)